<template>
  <div id="pAbout">
    <Nav type="transparent" />
    <span class="pageTitle">关于沙龙</span>
    <div class="pContent">
      <div class="blockTit" id="history">FK发展史</div>
      <div class="blockText">
        FK科技理容中心，创立于2013年，目前已成为国内一线的女性综合管理中心，引领着国内依托先进科技进行各项美态管理的新概念。
      </div>
      <div class="blockText">
        FK目前业务构成为：医疗美容，皮肤管理，头皮管理，身体智能管理，目前在中国北京有八家直营门店，分别覆盖北京最热门的八大商圈。
      </div>
      <div class="about-photo clearfix">
        <img src="../assets/about-photo2.jpg" alt="" />
      </div>
    </div>

    <div style="margin-top: 80px; padding-top: 80px; padding-bottom: 52px; background: #f8f9f8;">
      <div class="pContent">
        <div class="blockTit" id="star" style="margin-top: 0;">明星会员</div>
        <div class="blockText">
          FK服务于各个行业的高端客户，并受到众多中国明星的青睐，如中国的钢琴王子郎朗，中国国内一线明星王鸥，董洁等，都是FK的固定会员客人。
        </div>
        <div class="blockText">
          “美丽俏佳人”是一档中国非常热门的电视美妆栏目，栏目组深度探访了FK的头皮管理项目，并给予了很高的评价。
        </div>
        <div class="about-banner" style="margin-top: 70px;">
          <div class="mid-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-1.jpg" alt="" />
                <p>FK明星会员-王鸥</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-2.jpg" alt="" />
                <p>FK明星会员-郎朗</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-3.jpg" alt="" />
                <p>FK明星会员-柳岩</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-4.jpg" alt="" />
                <p>FK明星会员-董洁</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-5.jpg" alt="" />
                <p>FK明星会员-于莎莎</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-6.jpg" alt="" />
                <p>FK明星会员-金大川</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-7.jpg" alt="" />
                <p>FK明星会员-欧豪</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-8.jpg" alt="" />
                <p>FK明星会员-李斯羽</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-9.jpg" alt="" />
                <p>FK明星会员-张小斐</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-10.jpg" alt="" />
                <p>FK明星会员-尤靖茹</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-11.jpg" alt="" />
                <p>FK明星会员-郭晓婷</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-12.jpg" alt="" />
                <p>FK明星会员-崔志佳</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-13.jpg" alt="" />
                <p>FK明星会员-张浩然</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-14.jpg" alt="" />
                <p>FK明星会员-吕夏</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-15.jpg" alt="" />
                <p>FK明星会员-何泓姗</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-16.jpg" alt="" />
                <p>FK明星会员-孔令令</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-17.jpg" alt="" />
                <p>FK明星会员-吕丽萍</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-18.jpg" alt="" />
                <p>FK明星会员-张琪</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-19.jpg" alt="" />
                <p>FK明星会员-许飞</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-20.jpg" alt="" />
                <p>FK明星会员-徐乐同</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-21.jpg" alt="" />
                <p>FK明星会员-赵楚仑</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-22.jpg" alt="" />
                <p>FK明星会员-张宁江</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-23.jpg" alt="" />
                <p>FK明星会员-严艺丹</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-24.jpg" alt="" />
                <p>FK明星会员-徐洁儿</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-25.jpg" alt="" />
                <p>FK明星会员-李媛</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-26.jpg" alt="" />
                <p>FK明星会员-梅林</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-27.jpg" alt="" />
                <p>FK明星会员-刘美含</p>
              </div>
              <div class="swiper-slide">
                <img src="../assets/about-m-slide-28.jpg" alt="" />
                <p>FK明星会员-张恋歌</p>
              </div>
            </div>
            <div class="mid-pagination"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="pContent">
      <div class="blockTit" id="brand" style="margin-top: 80px;">品牌合作</div>
      <div class="blockText">
        FK科技理容中心，创立于2013年，目前已成为国内一线的女性综合管理中心，引领着国内依托先进科技进行各项美态管理的新概念。FK服务各个行业的高端客户,受到众多明星朋友的青睐，积累了上万名的高品质的稳定客户。业务范围涵盖皮肤管理，头皮管理，身体智能管理，与日本、美国、西班牙等一线的美容机构建立了稳定的战略合作关系。
      </div>
      <div class="about-banner about-display" style="margin-top: 66px; padding-bottom: 140px;">
        <div class="item">
          <div class="imgBox">
            <img src="../assets/about-b-slide1.jpg" alt="" />
          </div>
          <p>
            日本厚生劳动省认证的日本本土美容沙龙新贵品牌，由曾在SHISEIDO（资生堂）日本横滨研发中心工作多年的元老级研究员精心培育，怀揣对极致产品力的匠心，倡导“美，从素颜开始”的品牌理念，坚持“以成分，打动肌肤”的核心精神，引领更多女性在重焕健康美丽肌肤的同时，重塑自信和魅力。
          </p>
        </div>
        <div class="item">
          <div class="imgBox">
            <img src="../assets/about-b-slide2.jpg" alt="" />
          </div>
          <p>
            1921年在日本创立，隶属日本takarabelmont集团,美容材顶尖品牌,专注于提供沙龙设计、高品位美容设备的企业TAKARA BELMONT创立至今九十多年,一直秉持美丽和健康共存这一理念,专注于让更多人健康而美丽地生活。
          </p>
        </div>
        <div class="item">
          <div class="imgBox">
            <img src="../assets/about-b-slide3.jpg" alt="" />
          </div>
          <p>
            INDIBA在欧洲及日本医疗美容和生活美容行业享有很高赞誉。全球的顶级会所、美容沙龙医疗机构都在使用INDIBA，帮助深受现代社会种种压力的人们加速代谢、燃烧脂肪、深度温热、改善各种身体和面部健康问题。
          </p>
        </div>
        <div class="item">
          <div class="imgBox">
            <img src="../assets/about-b-slide5.jpg" alt="" />
          </div>
          <p>
            LebeL是TAKARA BELMONT集团旗下的化妆品牌之一，主要生产经营面向美发美容行业的头发用品。LebeL作为主打品牌，以美与个性为理念，融入最人性化的产品设计和环保素材相结合元素，不断寻求高品质、高专业技术以及生产顺应时代价值的产品。
          </p>
        </div>
      </div>
    </div>
    <ToTop />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import ToTop from '@/components/ToTop.vue';
require('@/utils/swiper.min.js');
import('@/utils/swiper.min.css');
export default {
  name: 'pAbout',
  data() {
    return {};
  },
  components: {
    Nav,
    ToTop,
  },
  computed: {},
  methods: {
    getPosition() {
      let offset = 0;
      if (this.$route.params.position) {
        switch (this.$route.params.position) {
          case 'history':
            offset = document.querySelector('#history').offsetTop - 80;
            break;
          case 'star':
            offset = document.querySelector('#star').offsetTop - 80;
            break;
          case 'brand':
            offset = document.querySelector('#brand').offsetTop - 80;
            break;
        }
      }
      document.querySelector('#app').scrollTop = offset;
    },
    initMswiper() {
      new Swiper('.mid-container', {
        slidesPerView: 4,
        spaceBetween: 20,
        // centeredSlides: true,
        // loop: true,
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.mid-pagination',
          dynamicBullets: true,
          clickable: true,
        },
      });
    },
  },
  mounted() {
    this.initMswiper();
    setTimeout(() => {
      this.getPosition();
    }, 200);
  },
};
</script>

<style lang="scss" scoped>
#pAbout {
  padding: 350px 0 40px;
  background: url(../assets/pAbout-banner.jpg) top/auto 350px no-repeat;
}
.pContent {
  margin: 0 auto;
  width: 90%;
  max-width: 1200px;
  @media (width: 1024px) {
    width: 980px;
  }
}
.blockTit {
  margin: 90px 0 30px;
}
.blockText {
  font-size: 14px;
  line-height: 30px;
}
.about-photo {
  margin-top: 72px;
  > img {
    display: block;
    margin: 0 auto;
    width: 595px;
  }
}
.about-banner {
  position: relative;
  overflow: hidden;
}
.mid-container {
  padding-bottom: 70px;
  .swiper-slide {
    width: 290px;
    img {
      display: block;
      width: 100%;
    }
    p {
      margin-top: 16px;
      font-size: 14px;
      line-height: 16px;
      color: #555;
      text-align: center;
    }
  }
}

.about-display {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .item {
    flex: 1;
    margin: 0 10px;
    // width: 24.33%;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    .imgBox {
      position: relative;
      img {
        display: block;
        width: 100%;
      }
      // &::after {
      //     content: '';
      //     position: absolute;
      //     left: 0;
      //     top: 0;
      //     width: 100%;
      //     height: 100%;
      //     background: rgba(60, 46, 30, .15);
      //     opacity: 0;
      //     transition: all .5s;
      // }
      // &:hover::after {
      //     opacity: 1;
      // }
    }
    p {
      margin-top: 30px;
      padding: 0 4px;
      font-size: 12px;
      line-height: 24px;
    }
  }
}
.mid-container .swiper-button-next,
.mid-container .swiper-button-prev {
  top: 35%;
  width: 49px;
  height: 49px;
  background: none;
  transition: all 0.2s;
  outline: 0;
  opacity: 0;
  transform: translateX(50px);
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../assets/pIndex-next.png) no-repeat;
    transition: all 0.3s;
  }
  &:hover::after {
    transform: scale(1.1);
  }
}
.mid-container .swiper-button-prev {
  transform: translateX(-50px);
  &::after {
    background: url(../assets/pIndex-prev.png) no-repeat;
  }
}
.mid-container:hover .swiper-button-next,
.mid-container:hover .swiper-button-prev {
  transform: translateX(0);
  opacity: 1;
}
</style>
<style lang="scss">
#pAbout .mid-pagination {
  position: static;
  left: auto;
  // bottom: 0;
  margin-left: auto;
  margin-right: auto;
  width: 200px;
  height: 50px;
  text-align: center;
  overflow: hidden;
  transform: none;
  span {
    top: 10px;
    margin: 0 15px !important;
    // width: 14px!important;
    // height: 14px!important;
    background: transparent;
    border-radius: 0 !important;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: #acacac;
      transform: rotate(45deg);
    }
    &.swiper-pagination-bullet-active::after {
      background: #818181;
    }
  }
}
</style>
